<template>
    <b-container class="my-3 py-3">
        <b-form-group
            label="Template Name"
            label-for="order-template-name"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-input
                id="order-template-name"
                placeholder="Enter the name of the order template"
                v-model="model.order_template_name"
            >
            </b-form-input>
        </b-form-group>
        <b-form-group
            id="order_category_id-group"
            label="Category:"
            label-class="font-weight-bold pt-0"
            label-for="order_category_id"
            label-cols="3"
        >
            <b-form-select
                id="order_category_id"
                v-model="model.order_category_id"
                required
                :options="
                    categories.map(x => ({
                        value: x.id,
                        text: x.name,
                    }))
                "
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Template Category</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>
    </b-container>
</template>

<script>
export default {
    data() {
        return {
            model: {
                order_category_id: null,
                order_template_name: null,
            },
        }
    },
    props: ['value'],
    filters: {},
    created() {
        this.$store.dispatch('orderCategory/fetchAll')
    },
    mounted() {
        this.setTemplate(this.value || {})
    },
    watch: {
        value: function (val) {
            this.setTemplate(val)
        },
        order_template_id: function (val) {
            this.$emit('input', val)
        },
        'model.order_template_name': function (name) {
            this.model.order_template_name = name
            this.$emit('input', this.model)
        },
        'model.order_category_id': function (id) {
            this.model.order_category_id = id
            this.$emit('input', this.model)
        },
    },
    computed: {
        categories() {
            return this.$store.state.orderCategory.categories
        },
    },

    methods: {
        setTemplate(val) {
            this.model.order_template_name = val.order_template_name
            this.model.order_category_id = val.order_category_id
        },
    },
}
</script>
